import React from 'react';

export interface ConfirmOrderModalProps {
    isOpen: boolean;
    message: string;
    onConfirm: () => void | Promise<void>;
    onCancel: () => void;
}

export interface ModalAction {
    message: string;
    onConfirm: () => Promise<void>;
}

export const ConfirmOrderModal: React.FC<ConfirmOrderModalProps> = (props) => {
    if (!props.isOpen) return null;

    return (
        <div className="modal-overlay" onClick={props.onCancel}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <p>{props.message}</p>
                <div className="modal-footer">

                    <button className="button" onClick={props.onCancel}>
                        Close
                    </button>

                    <button className="button button--green" onClick={props.onConfirm}>
                        Confirm
                    </button>
                    
                </div>
            </div>
        </div>
    );
}